import { atom, useAtom } from 'jotai';

export const formInputEnabledAtom = atom(true);

export function useFormInputEnabledAtom() {
  return useAtom(formInputEnabledAtom);
}